var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"sw-Button3DModel",on:{"click":_vm.open3DModel}},[_vm._t("default",function(){return [_vm._m(0)]})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"sw-Button3DModel_Wrapper",attrs:{"role":"button"}},[_c('img',{staticClass:"sw-Button3DModel_Image",attrs:{"src":require("common/icon-360.svg"),"alt":""}})])
}]

export { render, staticRenderFns }